import React from "react"
import {languages} from "../locales/languages"
import {useLocale} from "../context/AppContext"

const linkRegex = /\{\{link:(https?:\/\/[^|}]+)\|([^}]+)\}\}/g

function renderTranslation(key, language) {
  const dictionary = languages[language] || languages.en
  const text = dictionary[key] || key

  const parts = text.split(linkRegex).reduce((acc, part, index, array) => {
    if (index % 3 === 1) {
      acc.push(
        <a href={part} target="_blank" rel="noopener noreferrer" key={part}>
          {array[index + 1]}
        </a>
      )
    } else if (index % 3 === 0) {
      acc.push(part)
    }
    return acc
  }, [])

  return parts.length > 1 ? <>{parts}</> : text
}

export function useTranslation() {
  const {language} = useLocale()
  return (key) => renderTranslation(key, language)
}

export default useTranslation
